<div class="header-container">
	<div class="logo-container">
		<a href="#" class="sidebar-toggle" (click)="toggleSidebar()">
			<nb-icon [icon]="'menu-outline'"></nb-icon>
		</a>
		<a class="logo" href="#" (click)="navigateHome()"><span>Tennis Tool ADM</span></a>
		<button nbButton ghost class="ml-auto" (click)="changeTheme()"><nb-icon icon="moon-outline"></nb-icon></button>
	</div>
</div>
